import ViewAs from './ViewAs.component';

export default ViewAs;
